import script from "./potentialCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./potentialCard.vue?vue&type=script&setup=true&lang=ts"

import "./potentialCard.vue?vue&type=style&index=0&id=80e3e5e6&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80e3e5e6"]])

export default __exports__